import type { Coupon } from './coupons';
import type { PlanLevel } from '~/lib/.client/plans';

export type SubscriptionPlan = 'pro' | 'teams';

export const SUBSCRIPTION_INTERVALS = ['yearly', 'monthly'] as const;
export type SubscriptionInterval = (typeof SUBSCRIPTION_INTERVALS)[number];

export interface Subscription {
  nextMonthStartTimestamp: number;
  nextInvoiceAmount?: number;
  currentMonthStartTimestamp: number;
  interval: SubscriptionInterval;
  status: 'active' | 'canceled' | 'unknown' | 'past_due';
  currentPeriodEnd?: number;
  planCost: number;
  quantity: number;
  pendingUpdate?: {
    expiresAt: number;
    interval: SubscriptionInterval;
    level: PlanLevel;
  };
}

type StripeTierUpdateAction = 'update_now_with_proration' | 'update_now' | 'schedule_update' | 'cancel_downgrade';

export interface StripeSubscriptionSession {
  action: StripeTierUpdateAction;
  billingCycleAnchor: number;
  invoiceAmount: number;
  promotionCodeData: Coupon;
  quantity: number;
}
